module.exports = __webpack_public_path__ + "img/ar2021_icon-integrity.2323114f.png";